import { render } from "./UpdateHonor.vue?vue&type=template&id=5c66c1cc&scoped=true"
import script from "./UpdateHonor.vue?vue&type=script&lang=js"
export * from "./UpdateHonor.vue?vue&type=script&lang=js"

import "./UpdateHonor.vue?vue&type=style&index=0&id=5c66c1cc&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c66c1cc"]])

export default __exports__